import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProductCard from "../../../Product/ProductCard.jsx";
import usespaceStore from "../../../../Store/EventStore.jsx";
import useAppStore from "../../../../Store/SearchStore.jsx";
import Loader from "../../../Loader/Loader.jsx";
import Cookies from "js-cookie";
import EditableField from "../../../ui/EditableField.jsx";
import IconButton from "../../../ui/Button/IconButton.jsx";
import { useTranslation } from "react-i18next";

export default function Component() {
  const { t } = useTranslation();
  const [selectedspaceDetails, setSelectedspaceDetails] = useState("");
  const { spaceName } = useParams();
  const type = "spaces";
  const history = useHistory();

  const {
    setSearchText,
    getSuggestedGifts,
    gifts: suggestedGifts,
    isSearching,
  } = useAppStore();

  const { gifts, fetchEventOrSpaceDetails, handleEdit } = usespaceStore();

  const giftTitles = gifts.map((gift) => gift.title).join(", ") || "";
  const rawGiftTitles = gifts.map((gift) => gift.title);

  const FilteredSuggestedProducts = suggestedGifts.filter(
    (suggestedGift) => !rawGiftTitles.includes(suggestedGift.title)
  );

  const [spaceDetails, setspaceDetails] = useState({
    title: t("spaces"),
  });

  useEffect(() => {
    if (selectedspaceDetails) {
      setspaceDetails({
        title: selectedspaceDetails.spaceName || t("spaces"),
      });
    }
  }, [selectedspaceDetails, t]);

  useEffect(() => {
    const fetchSuggestedGiftsData = async () => {
      const cookie = Cookies.get();
      setSearchText(localStorage.getItem("searchText") || "");
      getSuggestedGifts(cookie, giftTitles);
    };

    const fetchData = async () => {
      const data = await fetchEventOrSpaceDetails(type, spaceName);
      setSelectedspaceDetails(data);
      fetchSuggestedGiftsData();
    };

    fetchData();
  }, [giftTitles, spaceName, type, fetchEventOrSpaceDetails, setSearchText, getSuggestedGifts]);

  const updatespaceDetail = (key, value) => {
    setspaceDetails((prev) => {
      const updatedspaceDetails = { ...prev, [key]: value };
      const updatedData = value;
      handleEdit("spaces", selectedspaceDetails.spaceName, updatedData)
        .then((response) => {
          if (response) {
            history.replace(`/spaces/${value}`);
          }
        })
        .catch((error) =>
          console.error("Error updating space details:", error)
        );
      return updatedspaceDetails;
    });
  };

  const handlePromptValidation = (giftID) => {
    let prompt = null;
    if (Array.isArray(selectedspaceDetails.giftID)) {
      for (let ids of selectedspaceDetails.giftID) {
        if (Array.isArray(ids) && ids.includes(giftID)) {
          prompt = ids[1] || null;
          break;
        }
      }
    }
    return prompt;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-4">
          <IconButton
            icon={<ArrowLeft className="h-5 w-5" />}
            variant="ghost"
            size="md"
            onClick={() => history.push('/spaces')}
            tooltip={t("back_to_spaces", { defaultValue: "Back to Spaces" })}
            className="hover:bg-gray-100"
          />
        </div>

        <div className="container space-y-4 mb-8">
          <EditableField
            initialValue={spaceDetails.title}
            onSave={(value) => updatespaceDetail("title", value)}
            className="text-3xl font-bold text-red-500"
          />
        </div>

        <div className="flex flex-col items-center sm:flex-wrap sm:justify-between">
          <h2 className="text-2xl font-semibold w-full text-center ">
            {t("saved_products_title")}
          </h2>
          <div className="flex flex-col items-end sm:flex-row sm:flex-wrap sm:justify-evenly">
            {!gifts || gifts.length === 0 ? (
              <p className="text-gray-500">
                {t("no_gifts_saved")}
              </p>
            ) : (
              gifts.map((gift) => (
                <ProductCard
                  variant="event"
                  key={gift._id}
                  id={gift._id}
                  title={gift.title}
                  image={gift.img}
                  url={gift.link}
                  price={gift.price}
                  country={gift.country}
                  description={gift.description}
                  explanation={gift.explanation}
                  lovemeter={gift.loveMeter}
                  rank={gift.rank}
                  categories={gift.categories}
                  categoriesTranslated={gift.categoriesTranslated}
                  name={spaceName}
                  type={type}
                  heart="delete"
                  prompt={handlePromptValidation(gift._id)}
                />
              ))
            )}
          </div>
        </div>

        <div className="bg-green-100 p-4 rounded-xl">
          <h2 className="text-2xl font-semibold w-full text-center mb-4 ">
            {t("suggested_products_title")}
          </h2>
          {isSearching ? (
            <div className="flex justify-center items-center ">
              <Loader className="h-8 w-8" />
            </div>
          ) : (
            <div className="flex flex-nowrap items-center overflow-x-auto gap-4">
              {FilteredSuggestedProducts &&
                FilteredSuggestedProducts.map((gift) => (
                  <ProductCard
                    variant="event"
                    key={gift._id}
                    id={gift._id}
                    title={gift.title}
                    image={gift.img}
                    url={gift.link}
                    price={gift.price}
                    country={gift.country}
                    description={gift.description}
                    explanation={gift.explanation}
                    lovemeter={gift.loveMeter}
                    rank={gift.rank}
                    categories={gift.categories}
                    categoriesTranslated={gift.categoriesTranslated}
                    name={spaceName}
                    type={type}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
